export default "__VITE_ASSET__BM_21PT5__"